var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.24 14.998C18.31 14.998 19.99 16.6797 19.99 18.7497L19.9883 20.6197C20.2417 25.2114 16.7083 27.4997 10.15 27.4997C3.61167 27.4997 0 25.243 0 20.6847V18.7497C0 16.6797 1.67833 14.998 3.75 14.998H16.24Z",
    fill: "#0270B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99971 12.5033C13.4524 12.5033 16.2514 9.70437 16.2514 6.25167C16.2514 2.79897 13.4524 0 9.99971 0C6.54701 0 3.74805 2.79897 3.74805 6.25167C3.74805 9.70437 6.54701 12.5033 9.99971 12.5033Z",
    fill: "#0270B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.24 14.998C28.3084 14.998 29.9884 16.6797 29.9884 18.7497V20.0647C30.215 24.1847 27.0884 26.248 21.3784 26.248C20.605 26.248 19.8734 26.208 19.1934 26.138C20.5367 24.898 21.2534 23.218 21.2484 21.0914L21.2334 20.5514L21.24 18.7497C21.24 17.2547 20.5834 15.9147 19.5434 14.998H26.24Z",
    fill: "#44A6E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.498 12.5C25.2595 12.5 27.498 10.2614 27.498 7.5C27.498 4.73858 25.2595 2.5 22.498 2.5C19.7366 2.5 17.498 4.73858 17.498 7.5C17.498 10.2614 19.7366 12.5 22.498 12.5Z",
    fill: "#44A6E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.24b460d5c2231367692d4005f27576b9.svg";
export { ForwardRef as ReactComponent };